import React from 'react';
import { Skeleton } from '@mui/material';

export const StatusCardSkeleton = () => (
    <div className="relative bg-white/80 backdrop-blur-sm overflow-hidden shadow-lg rounded-xl border border-gray-200/50 p-3 sm:p-4">
        <div className="flex items-center space-x-2 sm:space-x-3">
            <Skeleton variant="rounded" width={40} height={40} className="flex-shrink-0" />
            <div className="flex-1">
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="text" width="40%" height={32} />
            </div>
        </div>
    </div>
);

export const KeyTakeawaySkeleton = () => (
    <div className="rounded-xl border border-gray-200 bg-gray-50 p-6 shadow-sm">
        <div className="flex items-start justify-between mb-4">
            <Skeleton variant="rounded" width={40} height={40} />
            <Skeleton variant="rounded" width={60} height={20} />
        </div>
        <Skeleton variant="text" width="80%" height={32} className="mb-1" />
        <Skeleton variant="text" width="40%" height={24} className="mb-2" />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="90%" height={20} className="mb-4" />
        
        <div className="bg-white/60 rounded-lg p-3 mb-4">
            <Skeleton variant="text" width="30%" height={16} className="mb-2" />
            <Skeleton variant="text" width="100%" height={16} />
            <Skeleton variant="text" width="90%" height={16} />
        </div>

        <div className="flex items-center gap-2 pt-4 border-t border-gray-200/50">
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton variant="text" width="70%" height={20} />
        </div>
    </div>
);

export const ChartSkeleton = () => (
    <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200 h-full">
        <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-2">
                <Skeleton variant="text" width={200} height={32} />
            </div>
            <Skeleton variant="rounded" width={100} height={32} />
        </div>
        <div className="w-full flex items-center justify-center py-8">
            <Skeleton variant="circular" width={200} height={200} />
        </div>
        <div className="mt-4 flex justify-between">
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={100} height={20} />
        </div>
    </div>
);

export const BarChartSkeleton = () => (
    <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200 h-full">
        <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-2">
                <Skeleton variant="text" width={200} height={32} />
            </div>
            <Skeleton variant="rounded" width={100} height={32} />
        </div>
        <div className="space-y-4 py-4">
            {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="flex items-center gap-4">
                    <Skeleton variant="text" width={100} height={24} />
                    <Skeleton variant="rounded" width="60%" height={24} />
                </div>
            ))}
        </div>
        <div className="mt-4 flex justify-between">
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={100} height={20} />
        </div>
    </div>
);

export const LineChartSkeleton = () => (
    <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
        <Skeleton variant="text" width={150} height={32} className="mb-4" />
        <Skeleton variant="rectangular" width="100%" height={300} className="rounded-lg" />
    </div>
);

export const RecommendationSkeleton = () => (
    <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-2xl p-6 border border-blue-100 shadow-sm mt-8">
        <div className="flex items-center gap-3 mb-6">
            <Skeleton variant="rounded" width={40} height={40} />
            <div>
                <Skeleton variant="text" width={200} height={32} />
                <Skeleton variant="text" width={300} height={20} />
            </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="p-4 border-b border-gray-200 bg-gray-50 flex gap-4">
                <Skeleton variant="text" width={100} height={24} />
                <Skeleton variant="text" width={200} height={24} />
                <Skeleton variant="text" width={150} height={24} />
            </div>
            {[1, 2, 3].map((i) => (
                <div key={i} className="p-4 border-b border-gray-100 flex gap-4">
                    <Skeleton variant="rounded" width={80} height={24} />
                    <Skeleton variant="text" width="40%" height={24} />
                    <Skeleton variant="text" width="30%" height={24} />
                </div>
            ))}
        </div>
    </div>
);
